import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, Subject } from 'rxjs';
import { Area } from 'src/app/models/area.model';
import { ChecklistItem } from 'src/app/models/checklist-item.model';
import { TypeOfConnection } from 'src/app/models/customer.model';
import { SortByOptions } from 'src/app/models/installation.model';
import { KeyValueItem } from 'src/app/models/keyValueItem.model';
import { MeterValidationList, ValidationFilter } from 'src/app/models/meter-validation.model';
import { Region } from 'src/app/models/region.model';
import { AreaService } from 'src/app/services/area.service';
import { MeterValidationService } from 'src/app/services/meter-validation.service';
import {
  AuthService,
  GeographicalRegion,
  GeographicalRegionService,
  PermissionsService,
  SubGeographicalRegion,
  SubGeographicalRegionService,
} from 'shared-lib';
import { RegionService } from 'src/app/services/region.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-meter-validation-list-page',
  templateUrl: './meter-validation-list-page.component.html',
  styleUrls: ['./meter-validation-list-page.component.scss'],
})
export class MeterValidationListPageComponent implements OnInit {
  @Input() dateFrom: string;
  @Input() dateTo: string;
  countAssigned: number = 0;
  countRejected: number = 0;
  countApproved: number = 0;
  countSubmited: number = 0;
  count: number = 2;
  pageSize: number = 10;
  currentPage: number = 1;
  currentTab: number = 1;
  searchText: string = '';
  regions: Region[] = [];
  areas: Area[] = [];
  allAreas: Area[] = [];
  geographicalRegions: (GeographicalRegion & { checked?: boolean })[] = [];
  allSubGeographicalRegions: (SubGeographicalRegion & { checked?: boolean })[] = [];
  subGeographicalRegions: (SubGeographicalRegion & { checked?: boolean })[] = [];
  clicked: boolean = false;
  selectedAreas: number[] = [];
  selectedRegions: number[] = [];
  selectedSubGeographicalRegions: number[] = [];
  hasCimDataIntegration: boolean = false;
  selectedFilters: ChecklistItem[] = [];
  buName: string = this.translationService.getByKeyFromStorage('BU');
  utName: string = this.translationService.getByKeyFromStorage('UT');
  reset: boolean = false;
  stats: KeyValueItem[] = [];
  
  currentTabName: string = 'Assigned';
  sortByValue: SortByOptions = SortByOptions.NEWEST;
  searchTextUpdate = new Subject<string>();
  mapSortBy: Record<number, string> = {
    [SortByOptions.NEWEST]: 'COMMON.SORT_BY.NEWEST',
    [SortByOptions.OLDEST]: 'COMMON.SORT_BY.OLDEST',
  };
  sortByOptions = SortByOptions;
  sortByName: string = this.mapSortBy[SortByOptions.NEWEST];
  showSortBy: boolean = false;
  mvs: MeterValidationList[] = [];
  customerPhase: number = -1;
  customerPhaseOptions = [
    { name: 'Single Phase', value: TypeOfConnection.SinglePhase, translation: 'COMMON.CUSTOMER.PHASE_OPTIONS.SINGLE' },
    { name: 'Three Phase', value: TypeOfConnection.ThreePhase, translation: 'COMMON.CUSTOMER.PHASE_OPTIONS.THREE' },
  ];

  addressValidation: number = -1;
  dtValidation: number = -1;
  addressAndDtValidations = [
    { name: 'Valid', value: ValidationFilter.Valid, translation: 'METER_VALIDATION.VALIDATION.VALID' },
    { name: 'Invalid', value: ValidationFilter.Invalid, translation: 'METER_VALIDATION.VALIDATION.INVALID' },
  ];

  constructor(
    private toastr: ToastrService,
    public permissionsService: PermissionsService,
    private translationService: TranslationService,
    private regionService: RegionService,
    private areaService: AreaService,
    private meterValidationService: MeterValidationService,
    private authService: AuthService,
    private geographicalRegionService: GeographicalRegionService,
    private subGeographicalRegionService: SubGeographicalRegionService
  ) {
    this.hasCimDataIntegration = this.authService.hasCimDataIntegration;
  }
  ngOnInit(): void {
    if (this.hasCimDataIntegration) {
      this.getGeographicalRegions();
    } else {
      this.getRegions();
      this.getAreas();
    }
    this.searchTextUpdate.pipe(debounceTime(500)).subscribe((value) => {
      if (this.searchText == '') this.search();
    });
    this.reloadTable();
    this.getStats();

  }
  private getRegions() {
    this.regionService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.regions = responseData.data;
          // this.getAreas();
        } else if (response?.status == 204) {
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
  search() {
    this.reloadTable(1);
  }

  onFilterBy(option: any) {
    if (option === 'Total Meters Validated') {
      this.resetFilter(1);
      this.reloadTable(1);
    }
    else if (option === 'Total Meters with Wrong Address') {
      this.addressValidation = ValidationFilter.Invalid;
      this.reloadTable(1);
    }
    else if (option === 'Total Meters with Wrong DTs') {
      this.dtValidation = ValidationFilter.Invalid;
      this.reloadTable(1);
    }
  }
  datesValid() {
    if (this.dateFrom && this.dateTo) {
      const valid: boolean =
        new Date(this.dateFrom).getTime() <
        new Date(`${this.dateTo.toString()}T23:59:59`).getTime();
      return valid;
    }
    return false;
  }
  private getAreas() {
    this.areaService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.allAreas = responseData.data;
        } else if (response?.status == 204) {
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
  private getGeographicalRegions() {
    this.geographicalRegionService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.geographicalRegions = responseData.data;
          this.getSubGeographicalRegions();
        } else if (response?.status == 204) {
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
  private getSubGeographicalRegions() {
    this.subGeographicalRegionService.getAllForMappings().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.allSubGeographicalRegions = responseData.data;
        } else if (response?.status == 204) {
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
    private getStats() {
    this.meterValidationService.getStats(this.getFilterObject()).subscribe({
      next: (response) => {
        const data = response.body;
        if (data?.status === 200 || data?.status === 'OK') {
          data.data.forEach((element) => {
            if (element.key == 'Rejected') {
              this.countRejected = element.value;
              data.data = data.data.filter((item) => item != element);
            } else if (element.key == 'Submited') {
              this.countSubmited = element.value;
              data.data = data.data.filter((item) => item != element);
            } else if (element.key == 'Approved') {
              this.countApproved = element.value;
              data.data = data.data.filter((item) => item != element);
            } else if (element.key == 'Assigned') {
              this.countAssigned = element.value;
              data.data = data.data.filter((item) => item != element);
            }
          });
          this.stats = data.data;
        } else {
          this.toastr.error(data?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
  download() {
    let obj = this.getFilterObject();
    this.meterValidationService.download(obj).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.toastr.success('File downloaded');
          window.location.href = responseData.data;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => this.toastr.error('Error occured'),
    });
  }
  sortBy(option: SortByOptions) {
    this.sortByValue = option;
    this.sortByName = this.mapSortBy[option];
    this.reloadTable();
  }
  pageChange(value: any) {
    this.currentPage = value;
    this.reloadTable();
  }
  selectRegion(e: any) {
    //list of areas for selected regions
    this.areas = this.allAreas.filter((area) =>
      this.regions.some(
        (region) => region.id == area.regionId && region.checked
      )
    );
    this.allAreas.forEach((area) => {
      if (!this.areas.some((a) => a.id === area.id)) {
        area.checked = false; //uncheck areas for unchecked regions
      }
    });

    this.createFilterCards();
  }
  isAllCheckBoxChecked() {
    return false;
  }
  checkAllCheckBox(event: any) {}

  selectArea(e: any) {
    this.createFilterCards();
  }

  selectGeographicalRegion(e: any) {
    //list of sub geographical regions for selected geographical regions
    this.subGeographicalRegions = this.allSubGeographicalRegions.filter((sub) =>
      this.geographicalRegions.some(
        (region) => region.id == sub.geographicalRegion.id && region.checked
      )
    );
    this.allSubGeographicalRegions.forEach((sub) => {
      if (!this.subGeographicalRegions.some((s) => s.id === sub.id)) {
        sub.checked = false; //uncheck sub geographical regions for unchecked geographical regions
      }
    });

    this.createFilterCards();
  }

  selectSubGeographicalRegion(e: any) {
    this.createFilterCards();
  }
  removeFilter(item: ChecklistItem) {
    if (item.property == this.buName) {
      this.regions.forEach((region) => {
        if (region.name === item.selectedValue) {
          region.checked = false;
        }
      });
      this.clicked = !this.clicked;
    } else if (item.property == this.utName) {
      this.areas.forEach((area) => {
        if (area.name === item.selectedValue) {
          area.checked = false;
        }
      });
      this.clicked = !this.clicked;
    }
    else if (item.property == 'Customer Phase') {
      this.customerPhase = -1;
    } 
    else if (item.property == 'Address Validation') {
      this.addressValidation = -1;
    }
    else if (item.property == 'DT Validation') {
      this.dtValidation = -1;
    }
    else if (item.property == 'Geographical Region') {
      this.geographicalRegions.forEach((region) => {
        if (region.name === item.selectedValue) {
          region.checked = false;
        }
      });
      this.selectGeographicalRegion(event);
      this.clicked = !this.clicked;
    }
    else if (item.property == 'Sub Geographical Region') {
      this.subGeographicalRegions.forEach((sub) => {
        if (sub.name === item.selectedValue) {
          sub.checked = false;
        }
      });
      this.clicked = !this.clicked;
    }

    this.createFilterCards();
    this.reloadTable(1);
  }
  createFilterCards() {
    this.selectedFilters = [];

    let selectedAreas = this.areas.filter((x) => x.checked);
    let selectedRegions = this.regions.filter((x) => x.checked);
    let selectedGeoRegions = this.geographicalRegions.filter((x) => x.checked);
    let selectedSubGeoRegions = this.subGeographicalRegions.filter((x) => x.checked);
    this.selectedAreas = this.areas.filter((x) => x.checked).map((x) => x.id);
    this.selectedRegions = this.regions
      .filter((x) => x.checked)
      .map((x) => x.id);
    this.selectedSubGeographicalRegions = this.subGeographicalRegions
      .filter((x) => x.checked)
      .map((x) => x.id as number);
    //regions
    for (var i = 0; i < selectedRegions.length; i++) {
      this.selectedFilters.push(
        new ChecklistItem(
          this.buName,
          selectedRegions[i].name,
          'COMMON.BU.SINGLE'
        )
      );
    }

    //areas
    for (var i = 0; i < selectedAreas.length; i++) {
      this.selectedFilters.push(
        new ChecklistItem(
          this.utName,
          selectedAreas[i].name,
          'COMMON.UT.SINGLE'
        )
      );
    }

    //geographical regions
    for (var i = 0; i < selectedGeoRegions.length; i++) {
      this.selectedFilters.push(
        new ChecklistItem(
          'Geographical Region',
          selectedGeoRegions[i].name,
          'COMMON.GEOGRAPHICAL_REGION.SINGLE'
        )
      );
    }

    //sub geographical regions
    for (var i = 0; i < selectedSubGeoRegions.length; i++) {
      this.selectedFilters.push(
        new ChecklistItem(
          'Sub Geographical Region',
          selectedSubGeoRegions[i].name,
          'COMMON.SUB_GEOGRAPHICAL_REGION.SINGLE'
        )
      );
    }

    //customer phase
    if (this.customerPhase != -1) {
      let phase = this.customerPhaseOptions.filter(
        (x) => x.value == this.customerPhase
      )[0];
      this.selectedFilters.push(new ChecklistItem('Customer Phase', phase.name, 'COMMON.CUSTOMER.CUSTOMER_PHASE', phase.translation));
    }

    // address validation
    if (this.addressValidation != -1) {
      let addressValidation = this.addressAndDtValidations.filter(
        (x) => x.value == this.addressValidation
      )[0];
      this.selectedFilters.push(new ChecklistItem('Address Validation', addressValidation.name, 'METER_VALIDATION.VALIDATION.ADDRESS_VALIDATION', addressValidation.translation));
    }

    // dt validation
    if (this.dtValidation != -1) {
      let dtValidation = this.addressAndDtValidations.filter(
        (x) => x.value == this.dtValidation
      )[0];
      this.selectedFilters.push(new ChecklistItem('DT Validation', dtValidation.name, 'METER_VALIDATION.VALIDATION.DT_VALIDATION', dtValidation.translation));
    }
  }
  reloadTable(page: any = null) {
    if (page) this.currentPage = page;
    let obj = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
        count: this.count,
      },
      filter: this.getFilterObject(),
    };

    this.getAll(obj);
  }
  getFilterObject() {
    let obj = {
      status: this.currentTab,
      dateFrom: this.dateFrom ? this.dateFrom : null,
      dateTo: this.dateTo ? `${this.dateTo}T23:59:59` : null,
      sortBy: this.sortByValue,
      searchFilter: this.searchText,
      areaIds: this.selectedAreas,
      subGeographicalRegionIds: this.selectedSubGeographicalRegions,
      customerPhase: this.customerPhase,
      addressValidation: this.addressValidation,
      dtValidation: this.dtValidation
     };
    return obj;
  }
  private getAll(obj: any) {
    this.meterValidationService.getAll(obj).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.mvs = responseData.data.data;
          this.count = responseData.data.count ?? this.count;
          this.createFilterCards();
          if (responseData.message != '') {
            this.toastr.warning(responseData.message);
          }
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => this.toastr.error('Error occured'),
    });
  }
  resetFilter(e: any) {
    this.selectedFilters = [];

    this.regions.forEach((region) => {
      region.checked = false;
    });

    this.areas.forEach((area) => {
      area.checked = false;
    });
    this.areas = [];

    this.geographicalRegions.forEach((region) => {
      region.checked = false;
    });

    this.subGeographicalRegions.forEach((sub) => {
      sub.checked = false;
    });

    this.subGeographicalRegions = [];
    this.selectedSubGeographicalRegions = [];
    this.clicked = !this.clicked;
    this.searchText = '';
    this.customerPhase = -1;
    this.addressValidation = -1;
    this.dtValidation = -1;

    this.reloadTable(1);
  }

  changeTab(page: number) {
    this.currentTab = page;
    if (this.currentTab == 4) {
      this.currentTabName = 'Assigned';
    } else if (this.currentTab == 3) {
      this.currentTabName = 'Rejected';
    } else if (this.currentTab == 2) {
      this.currentTabName = 'Approved';
    } else if (this.currentTab == 1) {
      this.currentTabName = 'Submitted';
    }

    this.searchText = '';
    this.resetFilter(1);
    this.reloadTable();
  }

  selectCustomerPhase(e: any) {
    this.customerPhase = +e.target.value;
    this.createFilterCards();
  }

  selectAddressValidation(e: any) {
    this.addressValidation = +e.target.value;
    this.createFilterCards();
  }
  
  selectDtValidation(e: any) {
    this.dtValidation = +e.target.value;
    this.createFilterCards();
  }
}
